// src/features/auth/useIsAdmin.ts
import { useMe } from './useMe'
import { useAppSelector } from '@/store/hooks'

export const useIsAdmin = () => {
  const { data, isLoading } = useMe()
  const forceIsAdmin = useAppSelector((s) => s.dev.forceIsAdmin)

  const baseline = data?.isAdmin ?? false
  const isAdmin = import.meta.env.DEV && forceIsAdmin ? true : baseline
  return { isAdmin, isLoading }
}
